import { getCountryForTimezone } from "countries-and-timezones";

/**
 * Get the user's country based on their time zone. Returns the Alpha-2 code of the country.
 * Includes robust error handling for Safari and module loading issues.
 */
export function getEstimatedUserCountry(): string | undefined {
  // Always return undefined on server to prevent hydration mismatches
  if (import.meta.server) return undefined;

  try {
    // Ensure we have a valid DateTimeFormat before proceeding
    const userTimeZone = Intl?.DateTimeFormat().resolvedOptions()?.timeZone;

    // Validate timezone before passing to library
    if (!userTimeZone || typeof userTimeZone !== "string") {
      return undefined;
    }

    // Wrap the countries-and-timezones call in additional error handling
    // This library has known iteration issues in certain browser conditions
    const countryResult = getCountryForTimezone(userTimeZone);

    // Validate the result structure before accessing properties
    if (
      countryResult &&
      typeof countryResult === "object" &&
      "id" in countryResult
    ) {
      return countryResult.id;
    }

    return undefined;
  } catch {
    return undefined;
  }
}
